import {
  EMAIL,
} from 'jl-design-system/form/fields';

export const getEmailField = (showPartnerAppText) => {

  if (showPartnerAppText) {
    return {
      ...EMAIL,
      label: "Customer's email",
    };
  }

  return {
    ...EMAIL,
    instruction: 'For receipts & order information only',
  };
};

export const GUEST_FORM_ID = 'guestForm';
export const guestFormConfig = showPartnerAppText => ({
  id: GUEST_FORM_ID,
  submitButton: 'Continue as guest',
  fields: [getEmailField(showPartnerAppText)],
});
